export default "__VITE_ASSET__CVUjr6KC__"